import React, { useState } from 'react';

import { Container, Title, FileName, StatusLabel } from './styles';
import { FileState, UploadStatus } from '../../reducer';
import { IconButton } from 'ui-components/src/components/atoms/IconButton';
import { CrossIcon } from 'ui-components/src/components/atoms/icons/CrossIcon';
import { Input } from 'ui-components/src/components/atoms/Input';
import FileTypeIcon from 'ui-components/src/components/atoms/icons/FileTypeIcon';

export const FileRow = ({
  fileState,
  onRemove,
  onSetName,
  disabled,
}: FileRowProps) => {
  const [validationError, setValidationError] = useState('');

  return (
    <Container key={fileState.id}>
      <Title>
        <FileTypeIcon mimeType={fileState.file.type} />
        <FileName>
          {fileState.file.name} ({formatFileSize(fileState.file.size)})
        </FileName>
        {!disabled && (
          <IconButton simple icon={<CrossIcon />} onClick={onRemove} />
        )}
      </Title>
      <Input
        placeholder="Name"
        disabled={disabled}
        label="Attachment name"
        value={fileState.name}
        onChange={(event) => {
          const validationResult = validateName(event.target.value);
          setValidationError(validationResult.message || '');
          onSetName(event.target.value);
        }}
        error={validationError}
      />
      <StatusLabel>{STATUS_LABELS[fileState.status]}</StatusLabel>
    </Container>
  );
};

const STATUS_LABELS: { [n in UploadStatus]: string } = {
  READY: 'Ready to upload',
  UPLOADING: 'Uploading...',
  UPLOAD_FAILURE: 'Error during upload',
  UPLOAD_SUCCESS: 'Upload completed',
  INVALID_SIZE: "This file is too large, it won't be uploaded",
};

function validateName(name: string): { isValid: boolean; message?: string } {
  if (!name) return { isValid: false, message: 'This field is required' };
  if (name.length > 50)
    return { isValid: false, message: 'This name is too long' };
  return { isValid: true };
}

function formatFileSize(bytes: number, decimals = 2): string {
  if (bytes === 0) return '0 Bytes';

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

export interface FileRowProps {
  fileState: FileState;
  disabled: boolean;
  onRemove: () => void;
  onSetName: (name: string) => void;
}
